var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHarbour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 5 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2513",
    transform: "translate(-505 -130)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Haven",
    transform: "translate(443 -2286.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun_1258518",
    className: "cls-2",
    d: "M18.452,5.968a3.162,3.162,0,0,1,.968,2.339,3.319,3.319,0,0,1-1.887,3v1.544h2.6a.458.458,0,0,1,.319.122.436.436,0,0,1,.135.319v1.947a.449.449,0,0,1-.135.331.431.431,0,0,1-.319.122h-2.6V24.06a7.583,7.583,0,0,0,4.41-2.462h-.686a.458.458,0,0,1-.319-.122.5.5,0,0,1-.122-.331.408.408,0,0,1,.1-.282l2.621-4.544a.4.4,0,0,1,.417-.294.413.413,0,0,1,.392.233l2.695,4.667a.506.506,0,0,1,.061.22.477.477,0,0,1-.135.331.414.414,0,0,1-.306.122H25.434a10.712,10.712,0,0,1-18.668,0H5.541a.414.414,0,0,1-.306-.122.464.464,0,0,1-.037-.612l2.621-4.544a.454.454,0,0,1,.821-.061l2.695,4.667a.4.4,0,0,1,.049.22.5.5,0,0,1-.122.331.458.458,0,0,1-.319.122h-.686a7.583,7.583,0,0,0,4.41,2.462V15.694h-2.6a.458.458,0,0,1-.319-.122.449.449,0,0,1-.135-.331V13.293a.436.436,0,0,1,.135-.319.458.458,0,0,1,.319-.122h2.6V11.308a3.319,3.319,0,0,1-1.887-3,3.16,3.16,0,0,1,.968-2.339,3.341,3.341,0,0,1,4.7,0ZM17.435,9.643a1.907,1.907,0,0,0,0-2.658A1.88,1.88,0,0,0,14.226,8.32a1.8,1.8,0,0,0,.551,1.323,1.825,1.825,0,0,0,1.323.539,1.865,1.865,0,0,0,1.335-.539Z",
    transform: "translate(65.701 2420.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarbour);
export default __webpack_public_path__ + "static/media/harbour.353a33ab6ea95d00cf20c0b8418e26dc.svg";
export { ForwardRef as ReactComponent };